// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"81d39063","878":"5670a8a0"}[chunkId] + ".chunk.js";
};